







































































import Multiselect from 'vue-multiselect';
import { Direction, GpioMutations, GpioPinConfig, IntMode, Line } from '@/store/gpio/types';
import { AugmentedProjectState } from '@/store/types';
import VueStrong from '@/vueStrong';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Multiselect,
  },
})
export default class GpioProperties extends VueStrong {
  IntMode = IntMode;

  constructor() {
    super();
  }

  isDuplicateLine(index: number): boolean {
    const config = this.configs[index];

    if (config.intMode === IntMode.None) 
      return false;

    return this.configs.some(e => (
      e.line === config.line &&
      e.pin !== config.pin &&
      e.intMode !== IntMode.None
    ));
  }

  changeConfig(index: number, config: Partial<GpioPinConfig>): void {
    this.$store.commit(GpioMutations.CHANGE_CONFIG_DATA, {
      data: config,
      index,
    });
  }

  get directions(): string[] {
    return Object.values(Direction);
  }

  get intModes(): string[] {
    return Object.values(IntMode);
  }

  getLineOptions(N: number): string[] {
    return [N % 8, (N+4) % 8].map(e => 'Line_' + e);
  }

  get configs(): GpioPinConfig[] {
    return this.$store.state.gpio.configs;
  }
}
